import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading || user === null) {
    return (
      <div className="flex items-center justify-center h-screen text-slate-500" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc }} replace />;
  }
  // Pending Google sign-ups have no role yet — punt them to the holding screen.
  if (user.pending_role || user.role == null || user.is_active === false) {
    return <Navigate to="/pending-approval" replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="p-10 text-center text-slate-600" data-testid="forbidden">
        You don't have access to this page.
      </div>
    );
  }
  return children;
}
